module.exports = __webpack_public_path__ + "static/MetadataDiagram-af73f98c9449f64c7da1fa04d945b06f.png";